/* global axios */
import ApiClient from '../ApiClient';

// Relatório de pendência por parceiro (Bloco 2 / T-05): ciclos encerrados no período.
class PendenciaRelatorioAPI extends ApiClient {
  constructor() {
    super('fandata/pendencia_relatorio', { accountScoped: true });
  }

  // T-259 (02/10): `parceiro` filtra a página inteira, não só uma tabela.
  get({ since, until, parceiro } = {}) {
    return axios.get(this.url, { params: { since, until, parceiro } });
  }

  // T-259: as conversas por trás de uma linha. `parceiro` ou `assunto`, nunca os dois.
  conversas({ since, until, parceiro, assunto } = {}) {
    return axios.get(`${this.url}/conversas`, {
      params: { since, until, parceiro, assunto },
    });
  }
}

export default new PendenciaRelatorioAPI();
